var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroupedEllipse(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1837,
    height: 1623,
    viewBox: "0 0 1837 1623",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e1919f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d9778a",
    stopOpacity: 0.11
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b991e1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b577d9",
    stopOpacity: 0.11
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-3",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5d57f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2f2c7c",
    stopOpacity: 0.431
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_25432",
    "data-name": "Group 25432",
    transform: "translate(340 567)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_78",
    "data-name": "Ellipse 78",
    cx: 260,
    cy: 260,
    r: 260,
    transform: "translate(-106 386)",
    opacity: 0.2,
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_79",
    "data-name": "Ellipse 79",
    cx: 497,
    cy: 497,
    r: 497,
    transform: "translate(-190 -417)",
    opacity: 0.2,
    fill: "url(#radial-gradient-2)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_77",
    "data-name": "Ellipse 77",
    cx: 260,
    cy: 260,
    r: 260,
    transform: "translate(827 80)",
    opacity: 0.2,
    fill: "url(#radial-gradient-3)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupedEllipse);
export default __webpack_public_path__ + "static/media/groupedEllipse.acde375f192d2174fa93bed4fec3f542.svg";
export { ForwardRef as ReactComponent };